/**
 * スタイル関係の初期化
 **/
$(function() {
  'use strict';

  //console.logが無いブラウザの対処
  if (typeof(window.console) === "undefined") {
    window.console = {
      log: function(){}, // 何もしない関数 とする
    };
  }


  //ツールチップを初期化
  if ( $.tooltip ) { 
    $('[data-toggle="tooltip"]').tooltip();
  }

  //特殊なスタイルの適用 //v2では不要になる
  //$('.box:has(.box-title)').addClass('box-has-title');

  //テーブルの横幅が収まっていない場合に横幅100%に
  $('table').each( function( ) {
    if ( $(this).width() > $(this).parent().width() - 20 ) {
      $(this).width('');
    }
  });


  //リフレッシュボタン
  $('.btn-refresh').click( function() {
    location.reload(true);
  });


  //デバイス出し分け
  if ( $.device.isMobile() ) {  $('.show-mobile').show(); $('.hide-mobile').hide(); }
  if ( $.device.isTablet() ) {  $('.show-tablet').show(); $('.hide-tablet').hide(); }
  if ( $.device.isMobileOrTablet() ) { $('.show-mobile-tablet').show(); $('.hide-mobile-tablet').hide(); }
  if ( $.device.isPc() ) { $('.show-pc').show(); $('.hide-pc').hide(); }
  if ( $.device.isIOS() ) { $('.show-ios').show(); $('.hide-ios').hide(); }
  if ( $.device.isAndroid() ) { $('.show-android').show(); $('.hide-android').hide(); }


  //最大まで高さを広げるフレーム
  $('.iframe-max-height').on('load',function() { 
    $(this).height(this.contentWindow.document.documentElement.scrollHeight);
  });


  //段組みメニューの見た目整える
  $('.menu-two-column .sub-menu .menu-item:last-child').each( function( i, elem ) {
    var num = $(elem).siblings('li').size();
    if ( num % 2 === 0 ) {
      $(elem).after('<li class="menu-item empty-menu-item">&nbsp;</li>');
    }
  });

  //コンバージョンリンクをOSで出し分け
  $('.cv-link, .cv-event').each( function ( i, elem ) {
    var new_url = null;
    if ( $.device.isIOS() ) { 
      new_url = $(elem).data('ios-url');
    } else if ( $.device.isAndroid() ) { 
      new_url = $(elem).data('android-url');
    }
    if ( new_url ) {
      //コンバージョン用リンクを差し替え
      console.log(new_url);
      $(elem).data('cv_url', new_url );

      //遷移先リンクを差し替え
      var atag;
      if ( $(elem).prop('tagName') === 'A' ) { 
        atag = $(elem);
      } else {
        atag = $(elem).find('a');
      }
      atag.attr('href',new_url);
    }
  });


  //広告を消す
  moko.hideAd = function()  {
    moko._ad = $('#ad-overlay-mark').nextAll('div:first');
    moko._ad.hide();
  };

  //広告を再表示
  moko.showAd = function() {
    if ( moko._ad ) {
      moko._ad.show();
    }
  };




  //コピペ
  $('.copy-box-button').on( 'click', function() {
    var target_id = $(this).data('target');
    console.log(target_id);
    var range = document.createRange();
    var element = document.querySelector( target_id );
    range.selectNodeContents( element );
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    var result = document.execCommand('copy');
    if ( result ) {
      var message = $(target_id + "-message");
      //message.fadeOut(500, function() { message.fadeIn(500); } );
      message.hide();
      message.text("コピーしました");
      message.fadeOut(500).fadeIn(500);
    }
    selection.removeAllRanges();

  });

  //URLをコピー
  $('.copy-url-button').on( 'click' , function(e) {

    navigator.clipboard.writeText(moko.url).then(function() {
      var message = $('#sns-copy-message');
      //message.fadeOut(500, function() { message.fadeIn(500); } );
      message.hide();
      message.text("記事のURLをコピーしました");
      message.fadeOut(500).fadeIn(500);
    });
    return false;
  });


  //Loading表示 for v2
  moko.showLoading = function( message ) {
    if ( message ) { 
      $('#overlay-loading-message').html(message);
    }
    $('#overlay-screen').show();
  };
  moko.hideLoading = function() {
    $('#overlay-screen').hide();
  };


  console.log('init utils');

});


